import React from "react";
import styles from "./landing.module.css";
import Icon from "../../components/icons/icons";
import PubHeader from "../../components/header/pub/header";
import ieSvg from "../../components/icons/ieSvg";
import PageLoading from "../server/preload";

class LandingPage extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      skin: localStorage.getItem('faktura-skin'),
      registerNow: window.location.href.indexOf("?page=registerNow")
    }
  }

  componentDidMount() {
    ieSvg();
    if(this.state.registerNow > -1) {
      this.props.handleClick()
    }
  }

  prevSlide = () => {
    var sliderItems = document.getElementById("slider-items");
    var activeSlide = sliderItems.querySelector("[data-active]");
    var lastSlide = sliderItems.lastChild;
    var prevSlide = activeSlide.previousSibling;
    activeSlide.removeAttribute("data-active");
    if (prevSlide) {
      prevSlide.setAttribute("data-active", "");
    } else {
      lastSlide.setAttribute("data-active", "");
    }
  };

  nextSlide = () => {
    var sliderItems = document.getElementById("slider-items");
    var activeSlide = sliderItems.querySelector("[data-active]");
    var firstSlide = sliderItems.querySelector("div");
    var nextSlide = activeSlide.nextSibling;
    activeSlide.removeAttribute("data-active");
    if (nextSlide) {
      nextSlide.setAttribute("data-active", "");
    } else {
      firstSlide.setAttribute("data-active", "");
    }
  };

  focusBottom = () => {
    window.scrollTo({
      top: document.body.scrollHeight,
      behavior: "smooth"
    });
  };

  render() {
    if(this.state.registerNow > -1) {
      return <PageLoading />
    }
    else {
    return (
      <main>
        <PubHeader/>
        <div className={styles.landing}>
          <div className={styles.landing__slider}>
            <div id="slider-items">
              <div className={styles.landing__slider_item} data-active>
                <div className={styles.landing__slider_info}>
                  <div className={styles.landing__slider_title}>
                    Стать самозанятым <span onClick={this.focusBottom} style={{cursor: 'pointer'}}>*</span>
                  </div>
                  <div>
                    Вести свою деятельность официально просто.
                    Принимайте оплату от клиентов и оплачивайте налог онлайн.
                  </div>
                  <span className={styles.landing__button} onClick={this.props.handleClick}>Стать самозанятым</span>
                </div>
              </div>
              <div className={styles.landing__slider_item}>
                <div className={styles.landing__slider_info}>
                  <div className={styles.landing__slider_title}>
                    Стать самозанятым <span onClick={this.focusBottom} style={{cursor: 'pointer'}}>*</span>
                  </div>
                  <div>
                    Вести свою деятельность официально просто.
                    Принимайте оплату от клиентов и оплачивайте налог онлайн.
                  </div>
                  <span className={styles.landing__button} onClick={this.props.handleClick}>Стать самозанятым</span>
                </div>
              </div>
            </div>
            <div className={styles.landing__prev} id="slider-prev" onClick={this.prevSlide}>
              <Icon name="icon_arrow" viewbox="0 0 32 32"/>
            </div>
            <div className={styles.landing__next} id="slider-next" onClick={this.nextSlide}>
              <Icon name="icon_arrow" viewbox="0 0 32 32"/>
            </div>
          </div>
          <div className="inner">
            <div className="l-align_center">
              <div className={styles.landing__title}>Преимущества для вас</div>
            </div>
            <div className="clear">
              {(this.state.skin === 'siab' || this.state.skin === 'united') ? null : <div className={styles.landing__odds}>
                <Icon name="icon_landing01" viewbox="0 0 120 120"/>
                Автоматическая регистрация<br/>доходов от постоянных<br/>клиентов
              </div>}
              <div className={styles.landing__odds} style={{width: (this.state.skin === 'siab' || this.state.skin === 'united') ? '33%' : '25%'}}>
                <Icon name="icon_landing02" viewbox="0 0 120 120"/>
                Оплата налога<br/>
                онлайн
              </div>
              <div className={styles.landing__odds} style={{width: (this.state.skin === 'siab' || this.state.skin === 'united') ? '33%' : '25%'}}>
                {
                  this.state.skin === 'vesta' ?
                    <React.Fragment>
                      <Icon name="icon_landing03" viewbox="0 0 120 120"/>
                      5% на остаток по карте<br/>
                      с тарифом «Самозанятый»
                    </React.Fragment>
                    :
                    <React.Fragment>
                      <Icon name="icon_landing03_2" viewbox="0 0 120 120"/>
                      Предоставление чеков <br/>клиентам
                    </React.Fragment>
                }
              </div>
              <div className={styles.landing__odds} style={{width: (this.state.skin === 'siab' || this.state.skin === 'united') ? '33%' : '25%'}}>
                <Icon name="icon_landing04" viewbox="0 0 120 120"/>
                Удобный интерфейс для<br/>контроля расходов
              </div>
            </div>
            <div className={styles.landing__title}>
              Кто такой самозанятый?
            </div>
            <div className="clear">
              <div className={styles.landing__locations}>
                Ведет деятельность
                <div>
                  <a href="https://npd.nalog.ru/faq/" rel="noopener noreferrer" target="_blank">по всей России</a>
                </div>
              </div>
              <div className={styles.landing__income}>
                Получает доход
                <div>
                  до 2,4 млн рублей<br/>
                  в год
                </div>
              </div>
            </div>
            <div className="clear">
              <div className={styles.landing__owner}>
                Работает
                <div>
                  не привлекая наемных работников
                </div>
              </div>
              <div className={styles.landing__stage}>
                Продает
                <div>
                  свой собственный<br/>
                  труд (не занимается перепродажей)
                </div>
              </div>
            </div>
            <div className='l-align_center'>
              <div className={styles.landing__title}>
                Как зарегистрироваться в ФНС
              </div>
              <div className='l-grid_pt-6'>
                <div className='l-grid__item_2'>
                  <div className={styles.regStep}>1</div>
                  <div className={styles.regText}>Перейдите по кнопке<br/> "Стать самозанятым"<br/> на форму
                    регистрации
                  </div>
                </div>
                <div className='l-grid__item_2'>
                  <div className={styles.regStep}>2</div>
                  <div className={styles.regText}>Укажите ваш вид деятельности и<br/> регион, подтвердите
                    кнопкой<br/> «Пройти регистрацию»
                  </div>
                </div>
                <div className='l-grid__item_2'>
                  <div className={styles.regStep}>3</div>
                  <div className={styles.regText}>Дождитесь ответа от ФНС и<br/> регистрируйте доходы в
                    личном<br/> кабинете
                  </div>
                </div>
              </div>
              <div className={styles.regText} style={{marginBottom: '120px'}}>
                Вся подробная информация на сайте ФНС <a target="_blank" rel="noopener noreferrer"
                                                         href="https://npd.nalog.ru">npd.nalog.ru</a> в разделе <a
                target="_blank" rel="noopener noreferrer" href="https://npd.nalog.ru/faq/">Вопросы</a>
              </div>
            </div>

          </div>
          <div className={styles.landing__wrapper}>
            <div className={styles.landing__cheque}/>
            <div className="inner">
              <div className={styles.landing__inner}>
                <div className={styles.landing__title}>
                  Доверие к вам
                </div>
                <ul className={styles.landing__list}>
                  <li>
                    <div className={styles.landing__list_infotitle}>Формируйте электронные чеки</div>
                    <div className={styles.landing__list_info}>
                      при получении платежей от клиентов и укрепите их доверие к вам
                    </div>
                  </li>
                  {(this.state.skin === 'siab' || this.state.skin === 'united') ? null : <li>
                    <div className={styles.landing__list_infotitle}>Ведите каталог постоянных клиентов</div>
                    <div className={styles.landing__list_info}>
                      с возможностью формировать чеки автоматически
                    </div>
                  </li>}
                </ul>
              </div>
            </div>
          </div>
          <div className={styles.landing__footer} style={{paddingTop: (this.state.skin === 'siab' || this.state.skin === 'united') ? '22rem' : '16.3125rem'}}>
            <div className="inner">
              <div className={styles.landing__footer_title}>
                Налоги
              </div>
              <div className="l-grid">
                <div className="l-grid__item_3">
                  <div className={styles.landing__footer_white}>
                    <div>4 %</div>
                    если работаете<br/>
                    с физическими<br/>
                    лицами
                    <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                  </div>
                </div>
                <div className="l-grid__item_3">
                  <div className={styles.landing__footer_white}>
                    <div>6 %</div>
                    если работаете<br/>
                    с юридическими<br/>
                    лицами
                    <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                  </div>
                </div>
                <div className="l-grid__item_6">
                  <div className={styles.landing__footer_black}>
                    <div>налоговый вычет</div>
                    10 000 рублей<br/>
                    и снижение ставки
                    <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                  </div>
                </div>
              </div>
              <div className="l-grid">
                <div className="l-grid__item_6">
                  <div className={styles.landing__footer_red}>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Не нужно платить <br/>страховые взносы
                    </div>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Без отчетности и <br/>деклараций
                    </div>
                  </div>
                </div>
                <div className="l-grid__item_6">
                  <div className={styles.landing__footer_blue}>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Рассчитываются <br/>автоматически
                    </div>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Уплачиваются раз в месяц
                    </div>
                    <div>
                      <Icon name="icon_checkbox" viewbox="0 0 24 24"/>
                      Ставка налога не изменится<br/>
                      до 2029 года
                    </div>
                  </div>
                </div>
              </div>
              <div className="l-align_center">
                <span className={styles.landing__button} onClick={this.props.handleClick}>Стать самозанятым</span>
              </div>
              <div className="l-align_center" style={{marginTop: '10.625rem'}}>
                <div className={styles.footer__text}>
                  * Самозанятый – физическое лицо - налогоплательщик РФ, применяющий специальный налоговый режим<br/>
                  «Налог на профессиональный доход» (в соответствии с 422-ФЗ).
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
    )
  }
  }
}

export default LandingPage;
